/**
 * @prettier
 */
import * as React from 'react';

export function DoorHangerIcon({ title }: Props): React.ReactElement {
    return (
        <svg width='35' height='35' viewBox='0 0 35 35' fill='none' xmlns='http://www.w3.org/2000/svg'>
            {title && <title>{title}</title>}
            <rect width='35' height='35' rx='17.5' fill='#F1F1F1' />
            <path
                d='M12.4091 14.9872C11.9028 14.9872 11.4172 14.7886 11.0592 14.4352C10.7011 14.0818 10.5 13.6024 10.5 13.1026C10.5 11.2698 11.2375 9.5122 12.5503 8.21627C13.863 6.92035 15.6435 6.19231 17.5 6.19231C19.3565 6.19231 21.137 6.92035 22.4497 8.21627C23.7625 9.5122 24.5 11.2698 24.5 13.1026V26.2949C24.5 26.9613 24.2318 27.6005 23.7545 28.0717C23.2771 28.5429 22.6296 28.8077 21.9545 28.8077H13.0455C12.3704 28.8077 11.7229 28.5429 11.2455 28.0717C10.7682 27.6005 10.5 26.9613 10.5 26.2949V23.782C10.5 22.0482 11.4036 20.7114 12.8927 19.7929L18.5233 16.319C19.866 15.4897 20.6818 14.6655 20.6818 13.1026C20.6818 12.2695 20.3466 11.4706 19.7499 10.8815C19.1532 10.2925 18.3439 9.96154 17.5 9.96154C16.6561 9.96154 15.8468 10.2925 15.2501 10.8815C14.6534 11.4706 14.3182 12.2695 14.3182 13.1026C14.3182 13.6024 14.117 14.0818 13.759 14.4352C13.401 14.7886 12.9154 14.9872 12.4091 14.9872Z'
                stroke='#616B79'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}
type Props = {
    title: string;
};
